// Malá disketa v pravém horním rohu grafu — stáhne aktuálně zobrazený graf jako
// soubor. Sdíleno napříč všemi grafovými komponentami.
//
// Dva režimy zdroje:
//   <ChartDownloadButton data={jsonData} />   — data z JSON odpovědi grafu
//                                               (svg string / png|jpg base64), bez fetche
//   <ChartDownloadButton href={blobUrl} ext="png" />  — už hotový object URL (ChartImage)

function SaveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  )
}

const BTN_CLASS = 'p-1 rounded bg-white/70 text-gray-400 hover:text-blue-600 hover:bg-white ' +
  'backdrop-blur-sm transition-colors'
const BTN_STYLE = { position: 'absolute', top: 4, right: 4, zIndex: 20 }

function triggerDownload(url, filename, revoke) {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  if (revoke) URL.revokeObjectURL(url)
}

export function ChartDownloadButton({ data, href, ext, name = 'graf' }) {
  // Režim href — už máme object URL (ChartImage)
  if (href) {
    return (
      <button
        type="button"
        onClick={() => triggerDownload(href, `${name}.${ext || 'png'}`, false)}
        title="Stáhnout graf"
        aria-label="Stáhnout graf"
        style={BTN_STYLE}
        className={BTN_CLASS}
      >
        <SaveIcon />
      </button>
    )
  }

  // Režim data — JSON odpověď grafu
  const { svg, png, jpg } = data ?? {}
  const fmt = svg ? 'svg' : png ? 'png' : jpg ? 'jpg' : null
  if (!fmt) return null

  function handleDownload() {
    let blob
    if (svg) {
      blob = new Blob([svg], { type: 'image/svg+xml' })
    } else {
      const b64 = png || jpg
      const mime = png ? 'image/png' : 'image/jpeg'
      const bin = atob(b64)
      const bytes = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
      blob = new Blob([bytes], { type: mime })
    }
    triggerDownload(URL.createObjectURL(blob), `${name}.${fmt}`, true)
  }

  return (
    <button
      type="button"
      onClick={handleDownload}
      title="Stáhnout graf"
      aria-label="Stáhnout graf"
      style={BTN_STYLE}
      className={BTN_CLASS}
    >
      <SaveIcon />
    </button>
  )
}
